import { Action } from '@ngrx/store';

import { Password } from 'app/core/authentication/models';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';

export class PasswordUpdate implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordUpdate;
  public readonly payload: Password;

  constructor({ userId = undefined, password = undefined , ForcePassword = undefined }: Password) {
    this.payload = new Password({ userId, password, ForcePassword });
  }
}

export class PasswordUpdateCompleted implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordUpdateCompleted;

  constructor(public readonly payload: string) { }
}

export class PasswordUpdateFailed implements Action {
  public readonly type: AuthActionType = AuthActionType.PasswordUpdateFailed;

  constructor(public readonly payload: string) { }
}
